import { createIcon } from '@chakra-ui/react';

export default createIcon({
  displayName: 'SettingsIcon',
  viewBox: '0 0 24 24',
  defaultProps: {
    boxSize: 6,
  },
  path: (
    <>
      <path
        d="M9.59356 3.94005C9.68397 3.39759 10.1533 3 10.7033 3H13.2972C13.8472 3 14.3165 3.39759 14.4069 3.94005L14.6204 5.2211C14.6828 5.59514 14.9327 5.90671 15.2645 6.09036C15.3387 6.13142 15.412 6.17383 15.4844 6.21757C15.8095 6.41384 16.2048 6.47486 16.5604 6.34166L17.7772 5.88578C18.2922 5.69284 18.8712 5.90051 19.1462 6.37677L20.4432 8.62321C20.7181 9.09948 20.6085 9.70473 20.1839 10.0543L19.1795 10.8811C18.887 11.1219 18.742 11.4937 18.7491 11.8725C18.7498 11.9149 18.7502 11.9574 18.7502 12C18.7502 12.0426 18.7498 12.0851 18.7491 12.1275C18.742 12.5063 18.887 12.8781 19.1795 13.1189L20.1839 13.9457C20.6085 14.2953 20.7181 14.9005 20.4432 15.3768L19.1462 17.6232C18.8712 18.0995 18.2922 18.3071 17.7772 18.1142L16.5604 17.6583C16.2048 17.5251 15.8095 17.5862 15.4844 17.7824C15.412 17.8262 15.3387 17.8686 15.2645 17.9096C14.9327 18.0933 14.6828 18.4049 14.6204 18.7789L14.4069 20.0599C14.3165 20.6024 13.8472 21 13.2972 21H10.7033C10.1533 21 9.68397 20.6024 9.59356 20.0599L9.38005 18.7789C9.31771 18.4049 9.06774 18.0933 8.73597 17.9096C8.66179 17.8686 8.58847 17.8262 8.51604 17.7824C8.19101 17.5862 7.79568 17.5251 7.44011 17.6583L6.22325 18.1142C5.70826 18.3072 5.12926 18.0995 4.85429 17.6232L3.55731 15.3768C3.28234 14.9005 3.39199 14.2953 3.81657 13.9457L4.82092 13.1189C5.11343 12.8781 5.25843 12.5063 5.25141 12.1275C5.25063 12.0851 5.25023 12.0426 5.25023 12C5.25023 11.9574 5.25063 11.9149 5.25141 11.8725C5.25843 11.4937 5.11343 11.1219 4.82092 10.8811L3.81657 10.0543C3.39199 9.70475 3.28234 9.09949 3.55731 8.62323L4.85429 6.37679C5.12926 5.90052 5.70825 5.69286 6.22325 5.88579L7.4401 6.34167C7.79566 6.47487 8.19099 6.41385 8.51603 6.21758C8.58846 6.17384 8.66179 6.13142 8.73597 6.09036C9.06774 5.90671 9.31771 5.59514 9.38005 5.2211L9.59356 3.94005Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.3"
        fill="none"
      />
      <path
        d="M15 11.9999C15 13.6568 13.6569 14.9999 12 14.9999C10.3431 14.9999 9 13.6568 9 11.9999C9 10.3431 10.3431 8.99992 12 8.99992C13.6569 8.99992 15 10.3431 15 11.9999Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.3"
        fill="none"
      />
    </>
  ),
});
